/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const uploadCvRequestSchema = z.object({
  file: z.instanceof(File),
});
